import { IHeroCustomizerSliderItem } from '../../models/hero-customizer-slider-item';

export const customPaging = (items: IHeroCustomizerSliderItem[], index: number, productName: string): string => {
  const item = items[index];
  
  // Check if the item is a 3D view
  const content = item.is3DView
    ? `<div class="hero-customizer-v3__view-in-3d-icon" alt="${productName}"></div>`
    : `<img src="${item.url}?w=50&h=50&auto=format" alt="${productName}" />`;
  
  return `
    <button type="button" role="button" data-role="none">
      ${content}
    </button>
  `;
};
